import ServiceCategoryPage from '@/components/business/ServiceCategoryPage';
import { makeServiceCategoryPaths, makeServiceCategoryProps } from '@/lib/serviceCategoryFactory';
import { BusinessItem } from '@/core/models/businesses/businessList';
import { GetStaticPaths, GetStaticProps } from 'next';

const CATEGORY_ID = '1382';
const CATEGORY_LABEL = 'Financial Institutions';
const CATEGORY_SLUG = 'financial-institutions';
const CATEGORY_DESCRIPTION = 'Find financial institutions offering vehicle finance and related services near you. Compare banks and finance providers in your area.';
const TAGS: string[] = ['Vehicle Finance', 'Banks', 'WesBank', 'ABSA Vehicle Finance', 'Leasing'];

interface Props {
    businesses: BusinessItem[];
    pagination: { count: number; currentPage: number; totalPages: number };
    city: string;
    cityName: string;
}

export default function FinancialInstitutionsCityPage({ businesses, pagination, city, cityName }: Props) {
    return (
        <ServiceCategoryPage
            businesses={businesses}
            pagination={pagination}
            city={city}
            cityName={cityName}
            categoryId={CATEGORY_ID}
            categoryLabel={CATEGORY_LABEL}
            categorySlug={CATEGORY_SLUG}
            categoryDescription={CATEGORY_DESCRIPTION}
            tags={TAGS}
        />
    );
}

export const getStaticPaths: GetStaticPaths = makeServiceCategoryPaths();
export const getStaticProps: GetStaticProps = makeServiceCategoryProps(CATEGORY_ID);
